import React from "react";
import "./WhyDreamsSection.scss";

const WhyDreamsSection = () => {
  return (
    <section className="whyDreams" id="porque-dreams">
      <div className="container">
        <div className="whyDreams__header">
          <span className="whyDreams__tag">La diferencia está aquí</span>

          <h2>¿Por qué elegir Dreams XV?</h2>

          <p>
            Porque aquí no solo encuentras proveedores. Encuentras inspiración,
            opciones confiables y una forma más fácil de comenzar a planear uno
            de los días más importantes de tu vida.
          </p>
        </div>

        <div className="whyDreams__grid">
          <div className="whyDreams__card">
            <div className="whyDreams__icon">✨</div>
            <h3>Todo en un solo lugar</h3>
            <p>
              Descubre vestidos, maquillaje, fotografía, salones y mucho más
              dentro de una misma plataforma.
            </p>
          </div>

          <div className="whyDreams__card">
            <div className="whyDreams__icon">💎</div>
            <h3>Proveedores confiables</h3>
            <p>
              Explora opciones que te ayuden a tomar mejores decisiones y a
              encontrar justo lo que imaginas para tu evento.
            </p>
          </div>

          <div className="whyDreams__card">
            <div className="whyDreams__icon">⏳</div>
            <h3>Ahorro de tiempo</h3>
            <p>
              Evita buscar en muchos lugares y encuentra todo fácilmente con una
              experiencia más rápida y organizada.
            </p>
          </div>

          <div className="whyDreams__card">
            <div className="whyDreams__icon">💛</div>
            <h3>Inspiración para tu evento</h3>
            <p>
              Encuentra ideas, estilos y referencias visuales para imaginar y
              construir la fiesta de tus sueños.
            </p>
          </div>

          <div className="whyDreams__card">
            <div className="whyDreams__icon">📲</div>
            <h3>Contacto directo</h3>
            <p>
              Conecta directamente con los proveedores que más te gusten y da el
              siguiente paso para hacer realidad tu gran día.
            </p>
          </div>

          <div className="whyDreams__card">
            <div className="whyDreams__icon">🎯</div>
            <h3>Decisiones más fáciles</h3>
            <p>
              Compara opciones, encuentra lo que realmente te gusta y toma
              decisiones con más claridad sin complicarte.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyDreamsSection;
